import React from 'react';
import { Settings } from 'react-slick';
import { IProductSectionContext, ProductSectionContext } from '../ProductSection/ProductSection';
import bemBlock from '@gik/core/utils/bemBlock';
import Carousel from '@gik/ui/Carousel/Carousel';

const sliderSettings: Settings = {
  dots: true,
  infinite: true,
  speed: 500,
  autoplay: true,
};

export default function ProductPreview() {
  const { product } = React.useContext<IProductSectionContext>(ProductSectionContext);

  const bem = bemBlock('product-preview');
  return (
    <section className={bem()}>
      <Carousel className={bem('slider', [{ 'has-dots': product?.thumbnails?.length > 0 }])} {...sliderSettings}>
        {product?.thumbnails?.map((imageUrl, i) => (
          <img key={i} className={bem('image')} alt="Product image" src={imageUrl} />
        ))}
      </Carousel>
    </section>
  );
}
